const associateByWithValueMapper = <V, T>(
  list: V[],
  toKey: (value: V) => string,
  toValue: (v: V) => T,
): { [key: string]: T } =>
  list.reduce((acc: { [key: string]: T }, v: V) => {
    acc[toKey(v)] = toValue(v);
    return acc;
  }, {});

const associateByNoValueMapper = <V,>(
  list: V[],
  toKey: (value: V) => string,
): { [key: string]: V } =>
  associateByWithValueMapper(list, toKey, (value) => value);

export function associateBy<V, T>(
  list: V[],
  toKey: (v: V) => string,
  toValue: (v: V) => T,
): { [key: string]: T };

export function associateBy<V>(
  list: V[],
  toKey: (v: V) => string,
): { [key: string]: V };

export function associateBy<V, T>(
  list: V[],
  toKey: (v: V) => string,
  toValue?: (v: V) => T | V,
): { [key: string]: V | T } {
  return toValue
    ? associateByWithValueMapper(list, toKey, toValue)
    : associateByNoValueMapper(list, toKey);
}
